import { useState } from 'react';
import styles from './styles.module.css';

interface Props {
  options: {
    label: string;
    value: string;
  }[];
  onChange: (selected: string) => void;
}

export function ButtonGroup({ options, onChange }: Props) {
  const [selected, setSelected] = useState(options[0].value);

  function optionClick(value: string) {
    setSelected(value);
    onChange(value);
  }

  const renderOptions = options.map((option) => {
    const { label, value } = option;

    const isSelected = selected === value;

    return (
      <button
        data-selected={!isSelected ? `not-selected` : `selected`}
        className={`${styles.optionButton} box-border flex cursor-pointer items-center
          justify-center border border-l-0 border-solid border-neutral-500 bg-neutral-100
          px-4 text-font14 font-light text-neutral-500`}
        key={value}
        type="button"
        onClick={isSelected ? undefined : () => optionClick(value)}
      >
        {label}
      </button>
    );
  });

  return <div className={styles.buttonsWrapper}>{renderOptions}</div>;
}
